export default __webpack_public_path__ + "static/media/group-icon-white.6bb54811.svg";